import { DebtBuyerPayload, DebtBuyerResponse } from 'shared/types/customObject/CustomObject';
import { sdk } from 'sdk';

const useCustomObjects = () => {
  const getExcludedBrandsData = async (): Promise<any> => {
    const extensions = sdk.composableCommerce;
    const res = await extensions.customObjects.getExcludedBrandsData();
    return res.isError ? ({} as any) : res.data;
  };

  const getDebtBuyerData = async (): Promise<any> => {
    const extensions = sdk.composableCommerce;
    const res = await extensions.customObjects.getDebtBuyerData();
    return res.isError ? ({} as any) : res.data;
  };

  const getDebtBuyerDataByCode = async (payload: DebtBuyerPayload): Promise<DebtBuyerResponse> => {
    const extensions = sdk.composableCommerce;
    const result = await extensions.customObjects.getDebtBuyerDataByCode(payload);
    return result.isError ? ({} as DebtBuyerResponse) : result.data;
  };

  return {
    getDebtBuyerData,
    getExcludedBrandsData,
    getDebtBuyerDataByCode,
  };
};

export default useCustomObjects;
